import React from 'react';
import { Snackbar, SnackbarContent, IconButton } from '@material-ui/core';

export default class Toast extends React.Component {
  state = {
    open: true
  }

  handleClose = (event, reason) => {
    if (reason !== 'clickaway') {
      this.setState({open: false});
    }
  }

  render() {
    let { message, ...other } = this.props;

    return (
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}

        open={this.state.open}
        autoHideDuration={3000}
        onClose={this.handleClose.bind(this)}
        message={this.props.message}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Toast/Toast.jsx